import { MenuProductLabel } from '@app/graphql/types/graphql.ts';
import { ReactSVG } from 'react-svg';

const ProductLabelIcon = (props: { label: MenuProductLabel }) => {
  const getLabelModifier = (label: MenuProductLabel) => {
    switch (label) {
      case MenuProductLabel.Alcohol:
        return 'product-label--alcohol';
      case MenuProductLabel.Spicy:
      case MenuProductLabel.Hot:
      case MenuProductLabel.ExtraHot:
        return 'product-label--spicy';
      case MenuProductLabel.Vegan:
        return 'product-label--vegan';
      case MenuProductLabel.Vegetarian:
        return 'product-label--vegetarian';
      default:
        return '';
    }
  };

  const labelModifier = getLabelModifier(props.label);

  switch (props.label) {
    case MenuProductLabel.Alcohol: {
      return (
        <div className={`product-label ${labelModifier}`}>
          <ReactSVG
            className="product-label__icon"
            src="https://inhouse-storage.fra1.cdn.digitaloceanspaces.com/static/alcohol.svg"
            beforeInjection={(svg) => {
              svg.querySelector('path')?.setAttribute('fill', '#ffcc00');
              svg.classList.add('w-5', 'h-5');
            }}
          />
        </div>
      );
    }
    case MenuProductLabel.Spicy: {
      return (
        <div className={`product-label ${labelModifier}`}>
          <ReactSVG
            className="product-label__icon"
            src="https://inhouse-storage.fra1.cdn.digitaloceanspaces.com/static/spicy.svg"
            beforeInjection={(svg) => {
              svg.classList.add('w-5', 'h-5');
            }}
          />
        </div>
      );
    }
    case MenuProductLabel.Vegan: {
      return (
        <div className={`product-label ${labelModifier}`}>
          <ReactSVG
            className="product-label__icon"
            src="https://inhouse-storage.fra1.cdn.digitaloceanspaces.com/static/vegan.svg"
            beforeInjection={(svg) => {
              svg.querySelector('path')?.setAttribute('fill', '#00b359');
              svg.classList.add('w-5', 'h-5');
              svg.querySelector('path')?.setAttribute('stroke-width', '2');
            }}
          />
        </div>
      );
    }
    case MenuProductLabel.Hot: {
      return (
        <div className={`product-label ${labelModifier}`}>
          <ReactSVG
            className="product-label__icon"
            src="https://inhouse-storage.fra1.cdn.digitaloceanspaces.com/static/hot.svg"
            beforeInjection={(svg) => {
              svg.querySelector('path')?.setAttribute('fill', '#ff1a1a');
              svg.classList.add('w-5', 'h-5');
            }}
          />
        </div>
      );
    }
    case MenuProductLabel.ExtraHot: {
      return (
        <div className={`product-label ${labelModifier}`}>
          <ReactSVG
            className="product-label__icon"
            src="https://inhouse-storage.fra1.cdn.digitaloceanspaces.com/static/extra-hot.svg"
            beforeInjection={(svg) => {
              svg.querySelector('path')?.setAttribute('fill', '#990000');
              svg.classList.add('w-5', 'h-5');
            }}
          />
        </div>
      );
    }
    case MenuProductLabel.Vegetarian: {
      return (
        <div className={`product-label ${labelModifier}`}>
          <ReactSVG
            className="product-label__icon"
            src="https://inhouse-storage.fra1.cdn.digitaloceanspaces.com/static/vegetarian.svg"
            beforeInjection={(svg) => {
              svg.querySelector('path')?.setAttribute('fill', '#2e7d32');
              svg.classList.add('w-5', 'h-5');
            }}
          />
        </div>
      );
    }
  }
};

export default ProductLabelIcon;
